﻿angular.module('projectModule')
    .controller('InstallationOverigController',
        ['$scope', '$controller', 'ntaSharedLogic', 'ntaValidation', 'ntaDependencyValidation', 'InstallationOverigFactory',
function ($scope,   $controller,   ntaSharedLogic,   ntaValidation,   ntaDependencyValidation,   InstallationOverigFactory) {
    'use strict';
    const ctrl = this;
    const base = $controller('NTABaseController', { $scope: $scope })
    angular.extend(ctrl, base);

    //== Imports ==================================================================================
    ctrl.ntaValidation = ntaValidation;


    //== Instance data ============================================================================
    const logic = new InstallationOverigFactory(ntaDependencyValidation);

    const _subtitleByPropId = new Map(Object.entries({
        'OVERIG_INST_GT290': 'Gebouwautomatiseringssystemen',
        'OVERIG_INST_CO2_EM': 'Koolstofemissie',
    }));


    //== Exports ==================================================================================
    ctrl.logic = logic;
    ctrl.properties = logic.properties;
    ctrl.entdata = logic.entdata;
    ctrl.isReadOnly = logic.isReadOnly;
    ctrl.isHidden = logic.isHidden;
    ctrl.getCodedValues = logic.getCodedValues;

    ctrl.getForm = () => logic.form;
    ctrl.getPropData = prop => base.getPropData(prop, logic.entdata);
    ctrl.getPropertyType = prop => prop && prop.PropertyType;

    ctrl.getTitle = () => ntaSharedLogic.isEditingMeasure()
        ? 'Maatregel: wijzigen overige kenmerken'
        : 'Overige installatiekenmerken'

    Object.assign(ctrl, {
        getSubtitle,
        saveValue,
    });

    $scope.endFormValidation = logic.endFormValidation;


    //== Initialization ===========================================================================

    angular.element(function () { //alle touched properties valideren na het laden van form
        logic.startFormValidation();
        logic.setGeopend();
    });

    //== Implementation ===========================================================================

    function getSubtitle(prop) {
        return _subtitleByPropId.get(prop.Id) || '';
    } //-- end: getSubtitle -----------------------------------------------------------------------

    function saveValue(prop) {
        logic.saveValue(prop, logic.entdata);
        base.initializeUnitSpacing();
    } //-- end: saveValue -------------------------------------------------------------------------

}]);
